import { useEffect, useState } from 'react'

const useResetDataAndStep = ({
  appSteps,
}) => {
  const [data, setData] = useState({})
  const [step, setStep] = useState('')

  useEffect(() => {
    if (appSteps && appSteps.length === 0) {
      setData({})
      setStep('')
    }
  }, [appSteps])

  return {
    data,
    setData,
    step,
    setStep,
  }
}

export default useResetDataAndStep
